import React from 'react';

interface FontSizeSliderProps {
    label: string;
    value: number;
    onChange: (value: number) => void;
    min: number;
    max: number;
    disabled?: boolean;
    onFocus?: () => void;
    onBlur?: () => void;
}

export default function FontSizeSlider({ label, value, onChange, min, max, disabled, onFocus, onBlur }: FontSizeSliderProps) {
    const fillPercent = Math.min(100, Math.max(0, ((value - min) / (max - min)) * 100));

    return (
        <div className="font-size-slider">
            <p>
                <b>{label}</b>
                <span className="esl"> ({min}px – {max}px)</span>
            </p>
            <div className="font-size-slider-control">
                <input
                    type="range"
                    min={min}
                    max={max}
                    step={1}
                    value={value}
                    onChange={(e) => onChange(Number(e.target.value))}
                    disabled={disabled}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    style={{ '--range-pct': `${fillPercent}%` } as React.CSSProperties}
                />
                <span className="font-size-slider-value">{value}px</span>
            </div>
        </div>
    );
}